import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

/**
 * La organizacion: CrediTotal. Hay UNA y su codigo no se puede cambiar.
 * No es un listado: el back devuelve la ficha directa.
 */
@Injectable({ providedIn: 'root' })
export class OrganizationService {
  private baseUrl: string;

  constructor(private httpClient: HttpClient) {
    this.baseUrl = environment.BASE_LA;
  }

  /**
   * La ficha. Devuelve { organization, faltantes } donde `faltantes` son los
   * campos fiscales vacios — hoy son razon social, RIF y domicilio.
   * El front los muestra como PENDIENTES, no como error.
   */
  getOrganization = async (): Promise<any> =>
    lastValueFrom(this.httpClient.get<any>(`${this.baseUrl}/api/organization`));

  /** Actualizar. El back rechaza cambiar el `code`. */
  updateOrganization = async (datos: any): Promise<any> =>
    lastValueFrom(this.httpClient.put<any>(`${this.baseUrl}/api/organization`, datos,
      { headers: { 'content-type': 'application/json' } }));
}
